var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pdf-viewer-ui',{attrs:{"src":_vm.url}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }